import i18n from 'config/i18n';
import { getLocale } from 'utils/date';
import { NavigationDirection } from '../CalendarNavigationHandler.types';
import { GetShortCutsProps } from './utils.types';
import { ShortcutAction } from 'components/shared/ShortcutProvider';

const t = i18n.getFixedT(getLocale(), null, 'mrp.shortcuts.navigation');

export const getShortCuts = ({
  navigate,
  tabThroughEvents,
  active = true
}: GetShortCutsProps): ShortcutAction[] => {
  return [
    {
      name: 'up',
      label: t('up.label'),
      description: t('up.description'),
      callback: () => navigate(NavigationDirection.Up),
      activatorKey: 'ARROWUP',
      controllerKeys: [],
      active
    },
    {
      name: 'down',
      label: t('down.label'),
      description: t('down.description'),
      callback: () => navigate(NavigationDirection.Down),
      activatorKey: 'ARROWDOWN',
      controllerKeys: [],
      active
    },
    {
      name: 'left',
      label: t('left.label'),
      description: t('left.description'),
      callback: () => navigate(NavigationDirection.Left),
      activatorKey: 'ARROWLEFT',
      controllerKeys: [],
      active
    },
    {
      name: 'right',
      label: t('right.label'),
      description: t('right.description'),
      callback: () => navigate(NavigationDirection.Right),
      activatorKey: 'ARROWRIGHT',
      controllerKeys: [],
      active
    },
    {
      name: 'tab',
      // TODO: remove this comment when translations are added
      label: t('tabThroughEvents.label'),
      description: t('tabThroughEvents.description'),
      callback: () => tabThroughEvents?.(false),
      activatorKey: 'TAB',
      controllerKeys: [],
      active
    },
    {
      name: 'shiftTab',
      // TODO: remove this comment when translations are added
      label: t('tabThroughEventsBackwards.label'),
      description: t('tabThroughEventsBackwards.description'),
      callback: () => tabThroughEvents?.(true),
      activatorKey: 'TAB',
      controllerKeys: ['SHIFT'],
      active
    }
  ];
};
